<template>
<div class="my">
  <div class="cont">
    <div class="r1"><img @click="goback()" src="static/images/back.svg" alt=""><span>注册</span></div>
    <div class="c2"><span class="c4">手机号码</span><input class="phone" type="text" placeholder="请输入手机号"></div>
    <div class="c3"><span class="c4">验证码</span><input class="code" type="password" placeholder="请输入验证码"><span class="c41" :class="{'active': iscl}" @click="set()">获取验证码</span></div>
    <div class="c5"><img @click="xz" class="c51" src="static/images/xz.svg" alt=""><span class="c52">我已阅读并同意</span><span class="c53" @click="tiaoli">《注册条例》</span></div>
    <div class="me"></div>
    <div class="c6 active" @click="next()">下一步</div>
    <div class="zhezhao" v-show="zhezhao">
      <div class="zz">
        <div class="z0"><h2 style="font-size: 18px;font-weight: 600;text-align: center;padding-bottom: 32px">用户使用协议</h2></div>
        <div class="z1">
          <div style="font-size:12px;background:#fff;color:#333;padding:0 20px 20px;overflow-y: scroll;line-height:1.5 "><p style="text-align: justify;text-indent: 2em;font-size: 14px;">欢迎您注册成为“北京市博物馆大数据平台”网站用户。在注册前请您仔细阅读如下服务条款：</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">本服务协议双方为本网站与本网站客户，本服务协议具有合同效力。您确认本服务协议后，本服务协议即在您和本网站之间产生法律效力。请您务必在注册之前认真阅读全部服务协议内容，如有任何疑问，可向本网站咨询。 无论您事实上是否在注册之前认真阅读了本服务协议，只要您点击协议正本下方的"注册"按钮并按照本网站注册程序成功注册为用户，您的行为仍然表示您同意并签署了本服务协议。</p><h3 style="font-size: 16px;font-weight: 600;padding-top: 16px;padding-bottom: 16px;">协议细则</h3><p style="text-align: justify;text-indent: 2em;font-size: 14px;">1、本网站服务条款的确认和接纳</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">本网站各项服务的所有权和运作权归本网站拥有。</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">2、用户必须：</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">(1)自行配备上网的所需设备， 包括个人电脑、调制解调器或其他必备上网装置。</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">(2)自行负担个人上网所支付的与此服务有关的电话费用、 网络费用。</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">3、用户在本网站交易平台上不得发布下列违法信息：</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">(1)反对宪法所确定的基本原则的；</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">(2)危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">(3)损害国家荣誉和利益的；</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">(4)煽动民族仇恨、民族歧视，破坏民族团结的；</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">(5)破坏国家宗教政策，宣扬邪教和封建迷信的；</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">(6)散布谣言，扰乱社会秩序，破坏社会稳定的；</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">(7)散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">(8)侮辱或者诽谤他人，侵害他人合法权益的；</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">(9)含有法律、行政法规禁止的其他内容的。</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">4、有关个人资料</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">用户同意：</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">(1)提供及时、详尽及准确的个人资料。</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">(2)同意接收来自本网站的信息。</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">(3)不断更新注册资料，符合及时、详尽准确的要求。所有原始键入的资料将引用为注册资料。</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">5、服务条款的修改</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">本网站有权在必要时修改服务条款，本网站服务条款一旦发生变动，将会在重要页面上提示修改内容。如果不同意所改动的内容，用户可以主动取消获得的本网站信息服务。如果用户继续享用本网站信息服务，则视为接受服务条款的变动。本网站保留随时修改或中断服务而不需通知用户的权利。本网站行使修改或中断服务的权利，不需对用户或第三方负责。</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">6、用户的帐号、密码和安全性</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">一旦注册成功成为用户，将得到一个密码和帐号。若用户未能保管好自己的帐号和密码安全，将由个人承担全部后果。另外，每个用户都要对其帐户中的所有活动和事件负全责。用户可随时根据指示改变个人密码，也可以结束旧的帐户重开一个新帐户。用户若发现任何非法使用帐号或账号存在安全漏洞的情况，请立即通知本网站。</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">7、拒绝提供担保</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">用户明确同意信息服务的使用由用户个人承担风险。本网站不担保服务不会受中断，对服务的及时性、安全性以及出错发生都不作担保，但会在能力范围内，避免出错。</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">8、有限责任</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">本网站对任何直接、间接、偶然、特殊及继起的损害不负责任，这些损害来自：不正当使用本网站服务，或用户传送的信息不符合规定等。这些行为都有可能导致本网站形象受损，所以本网站事先提出这种损害的可能性，同时会尽量避免这种损害的发生。</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">9、信息的储存及限制</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">本网站有判定用户的行为是否符合本网站服务条款的要求和精神的权利，如果用户违背本网站服务条款的规定，本网站有权中断其服务的帐号。</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">10、用户管理</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">用户必须遵循：</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">(1) 使用信息服务不作非法用途。</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">(2) 不干扰或混乱网络服务。</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">(3) 遵守所有使用服务的网络协议、规定、程序和惯例。用户的行为准则是以因特网法规、政策、程序和惯例为根据的。</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">11、保障</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">用户同意保障和维护本网站全体成员的利益，负责支付由用户使用超出服务范围引起的律师费用、违反服务条款的损害补偿费用以及其它人使用用户的电脑、帐号和其它知识产权的追索费。</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">12、结束服务</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">用户或本网站可随时根据实际情况中断一项或多项服务。本网站不需对任何个人或第三方负责而随时中断服务。用户若反对任何服务条款的建议或对之后的条款修改有异议，或对本网站服务不满，用户可以行使如下权利：</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">(1) 不再使用本网站信息服务。</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">(2) 通知本网站停止对该用户的服务。</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">结束用户服务后，用户使用本网站服务的权利马上中止。从即时起，用户没有权利、本网站也没有义务传送任何未处理的信息或未完成的服务给用户或第三方。</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">13、通告</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">所有发给用户的通告都可通过重要页面的公告或电子邮件传送。服务条款的修改、服务变更、或其它重要事件的通告都会以此形式进行。</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">14、信息内容的所有权</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">本网站定义的信息内容包括：文字、软件、声音、相片、录象、图表；在广告中全部内容；本网站为用户提供的其它信息。所有这些内容受版权、商标、标签和其它财产所有权法律的保护。因此，用户只能在本网站和广告商授权下才能使用这些内容，而不能擅自复制、再造这些内容，或创造与内容有关的派生产品。</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">15、法律</p><p style="text-align: justify;text-indent: 2em;font-size: 14px;">本网站信息服务条款要与中华人民共和国的法律解释一致。用户和本网站一致同意服从本网站所在地有管辖权的法院管辖。</p></div>
        </div>
        <div class="z2"><div class="lo active" @click="lo()">已 同 意</div></div>
      </div>
    </div>
  </div>
  <div class="cont1">
    <div class="q2"><span class="q4">设置密码</span><input class="pass1" type="password" placeholder="请输入密码"></div>
    <div class="q3"><span class="q4">确认密码</span><input class="pass2" type="password" placeholder="请输入确认密码"></div>
    <div class="me1"></div>
    <div class="q6 active" @click="wanc()">完成</div>
  </div>
</div>
</template>

<script>
    import $ from 'jquery'
    import Vue from 'vue'
    import {api} from '../global/api';
    import { Indicator } from 'mint-ui';
    export default {
        name: "register",
      data () {
        return {
          zhezhao:false,
          xuan:true,
          iscode:true,
          count:60,
          iscl:false,
          isco:false,
          isMobile:/^1[3578]\d{9}$|^147\d{8}$/,       //手机号码验证规则
          // ispass:/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,10}$/, //密码验证 6-10位
          ispass:/^(?=.*?[a-zA-Z])(?=.*?[0-9]).{8,}$/,//必须包含字母、数字，且至少8位
          phone:"",
          code:"",
          sucode:"",
          pass1:"",
          pass2:"",
          ispass1:false,
          ispass2:false
        }
      },
      methods:{
        lo(){
          if($('.lo').hasClass("active")){
            return false;
          }else{
            this.zhezhao=false;
            $('.c51').attr("src","static/images/xz.svg");
          }
        },
        tiaoli(){
          this.zhezhao=true;
        },
        register(){
          this.$router.push({ path: 'register'})
        },
        xz(){
          if(this.xuan){
            $('.c51').attr("src","static/images/wxz.svg");
            this.xuan=false;
          }else{
            $('.c51').attr("src","static/images/xz.svg");
            this.xuan=true;
          }
        },
        set(){
          var _this=this;
          if(this.iscl){
            this.timeDown();
            console.log(this.phone);
            this.$http.get(api.code+"?phone="+this.phone+"&type=1").then(response  => {
              console.log(response);
              if(response.body.success==1){
                _this.isco=true;
                _this.sucode=response.body.others;
              }else{
                $('.me').text(response.body.data);
              }
            })
          }else{
            $('.me').text("请输入正确的手机号");
          }
        },
        // time(){
        //   this.count--;
        //   if(this.count==0){
        //     this.iscl=true;
        //     this.count=60;
        //     $('.c41').text("获取手机验证码").css({"cursor":"pointer","color":"#d8d8d8"});
        //     return false;
        //   }else{
        //     this.iscl=false;
        //     $('.c41').text(this.count+"秒后重新发送").css({"color":"#d8d8d8"});
        //   }
        //   console.log(333)
        //   setTimeout(this.time,1000);
        // },
        timeDown() {
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.iscl=false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                $('.c41').text(this.count+"秒后重新发送");
                this.count--;
              } else {
                this.iscl=true;
                $('.c41').text("获取手机验证码");
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        },
        jianting(){
          var _this=this;
          $('.phone').bind('input propertychange', function() {
            _this.phone=$('.phone').val();
            $('.me').text("");
            if(!_this.isMobile.test(_this.phone)){
              _this.iscl=false;
              if(!$('.c41').hasClass("active")){
                $('.c41').addClass("active");
              }
            }else if(_this.isMobile.test(_this.phone)){
              _this.iscl=true;
              $('.me').text("");
              $('.c41').removeClass("active");
            }
          })
          $('.code,.phone').bind('input propertychange', function() {
            _this.code=$('.code').val();
            console.log(_this.code,_this.phone,_this.isco)
            if(_this.code&&_this.phone&&_this.isco){
              $('.lo').css({"cursor":"pointer","background-color":"#c44d41"});
              $('.c6').removeClass("active");
            }else{
              if(!$('.c6').hasClass("active")){
                $('.c6').addClass("active")
              }
            }
          })
          $('.pass1').bind('input propertychange', function() {
            _this.pass1=$('.pass1').val();
            console.log(_this.pass1,_this.ispass.test(_this.pass1));
            if(_this.ispass.test(_this.pass1)){
              _this.ispass1=true;
              $('.me1').text(" ");
            }else{
              _this.ispass1=false;
              // $('.me1').text("密码必须包含一个数字和字母且在6-10位")
              $('.me1').text("密码必须包含字母、数字，且至少8位")
            }
          })
          $('.pass2').bind('input propertychange', function() {
            _this.pass2=$('.pass2').val();
            if(_this.pass2==_this.pass1){
              _this.ispass2=true;
              $('.me1').text("");
            }else{
              _this.ispass2=false;
              $('.me1').text("请输入相同的密码");
            }
            console.log(_this.ispass2,_this.ispass1)
            if(_this.ispass2 && _this.ispass1){
              $('.q6').removeClass("active");
            }else{
              if(!$('.q6').hasClass("active")){
                $('.q6').addClass("active");
              }
            }
          })
        },
        next(){
          if(!$('.c6').hasClass("active")){
            this.$http.get(api.checkCode, {
              params: {
                phone: this.phone,
                secretCode:this.code,
                token: this.sucode
              }
            }).then(response  => {
              if(response.body.success==1){
                this.sucode = response.body.others;
                $('.cont').css("display","none");
                $('.cont1').css("display","block");
              }else{
                $('.me').text("验证码错误");
              }
            })
            // if(this.code==this.sucode){
            //   $('.cont').css("display","none");
            //   $('.cont1').css("display","block");
            // }else{
            //   $('.me').text("验证码错误")
            // }
          }
        },
        wanc(){
          if($('.q6').hasClass("active")){
            return false;
          }else{
            // this.$http.get(api.register+"?phone="+this.phone+"&secretCode="+this.code+"&password="+this.pass1+"&token="+this.sucode).then(response  => {
            this.$http.post(api.register, {
              phone: this.phone,
              secretCode: this.code,
              password: this.$getRsaCode(this.pass1),
              token: this.sucode
            },{
              emulateJSON: true
            }).then(response  => {
              console.log(response);
              if(response.body.success==1){
                this.$router.push({ path: '/my'})
              }else{
                $('.me1').text(response.body.data);
              }
            })
          }
        },
        goback(){
          this.$router.go(-1);
        }
      },
      created(){


      },
      mounted(){
          this.jianting();
          $('.z1').scroll(function () {
          if($(this).scrollTop()>1700){
            $('.lo').removeClass('active');
          }
        })
        $('.zhezhao').css({"height":$(window).height()+"px","width":$(window).width()+"px"});
      },
      beforeDestroy() {
        clearInterval(this.timer)
        this.timer = null
      }
    }
</script>

<style scoped>
  input{
    border: none;
    outline: none;
    background-color: rgba(241, 241, 242, 1);
    color: rgb(153,153,153);
    font-size: 14px;
    height: 1.5rem;
    line-height: 1.5rem;
    /*margin-top: 0.15rem;
    margin-left: 0.5rem;*/
    position: absolute;
    top: 50%;
    left:4rem;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .my{
    padding-top: 0.9rem;
    padding-bottom: 4rem;
    background-image: url("../../static/images/re.png");
  }
  .cont{
    width: 17.25rem;
    height: 25.2rem;
    border-radius: 8px;
    background-color: rgba(255, 255, 255, 1);
    margin: 0 auto;
    padding-top: 0.7rem;
  }
  .r1{
    text-align: center;
    height: 1rem;
    line-height: 1rem;
  }
  .r1 img{
    float: left;
    margin-left: 0.75rem;
  }
  .r1 span{
    color: rgb(51,51,51);
    font-size: 0.8rem;
  }
  .code{
    width:6rem;
  }
  .c2{
    width: 15.75rem;
    height: 1.8rem;
    border-radius: 8px;
    background: rgb(241,241,241);
    margin: 2.1rem auto 0;
    position: relative;
  }
  .c3{
    width: 15.75rem;
    height: 1.8rem;
    border-radius: 8px;
    background: rgb(241,241,241);
    margin: 0.5rem auto 0;
    position: relative;
  }
  .c4{
    color: rgb(51,51,51);
    font-size: 0.7rem;
   /* margin-left: 0.5rem;*/
    position: absolute;
    top: 50%;
    left: .5rem;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .c5{
    width: 15.75rem;
    margin: 0.6rem auto 0;
  }
  .c51{
    width: 0.8rem;
    height: 0.8rem;
    transform: translateY(0.1rem);
  }
  .c52{
    font-size: 0.65rem;
    color: #666;
    margin-left: 0.5rem;
  }
  .c53{
    font-size: 0.65rem;
    color: rgba(196, 77, 65, 1);
    margin-left: 0.5rem;
  }
  .zhezhao{
    background-color: rgba(0,0,0,0.5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
  }
  .zz{
    width: 17.25rem;
    height: 25.2rem;
    padding-top: 0.7rem;
    border-radius: 8px;
    background-color: rgb(255, 255, 255);
    position: absolute;
    top: 0.9rem;
    left: 50%;
    transform: translateX(-50%);
    overflow-y: scroll;
  }
  .lo{
    margin: 0.5rem auto 1rem;
    width: 15.75rem;
    height: 1.8rem;
    line-height: 1.8rem;
    border-radius: 0.4rem;
    background-color: rgba(196, 77, 65, 1);
    text-align: center;
    color: #fff;
    font-size: 0.7rem;
    display: block;
    border: none;
    outline:none;
  }
  .lo.active{
    color: #999;
    background-color: #d8d8d8;
  }
  .z1{
    height: 19rem;
    overflow-y: scroll;
  }
  .z2{
    margin-top: 1rem;
  }
  .c41{
    font-size: 0.7rem;
    color: rgb(153,153,153);
    display: inline-block;
    float: right;
    height: 1.8rem;
    line-height: 1.8rem;
    margin-right: 0.5rem;
  }
  .c41.active{
    color: rgb(196,77,65);
  }
  .c6{
    margin: 0.5rem auto 1rem;
    width: 15.75rem;
    height: 1.8rem;
    line-height: 1.8rem;
    border-radius: 0.4rem;
    background-color: rgba(196, 77, 65, 1);
    text-align: center;
    color: #fff;
    font-size: 0.7rem;
    display: block;
    border: none;
    outline:none;
  }
  .c6.active{
    color: #999;
    background-color: #d8d8d8;
  }
  .me{
    font-size: 12px;
    color: #c44d41;
    margin: 0.5rem auto 0;
    width: 15.75rem;
    height: 12px;
  }
  .cont1{
    width: 17.25rem;
    height: 25.2rem;
    border-radius: 8px;
    background-color: rgba(255, 255, 255, 1);
    margin: 0 auto;
    padding-top: 0.7rem;
    display: none;
  }
  .me1{
    font-size: 12px;
    color: #c44d41;
    margin: 0.5rem auto 0;
    width: 15.75rem;
    height: 12px;
  }
  .q2{
    width: 15.75rem;
    height: 1.8rem;
    position: relative;
    border-radius: 8px;
    background: rgb(241,241,241);
    margin: 2.1rem auto 0;
  }
  .q3{
    width: 15.75rem;
    position: relative;
    height: 1.8rem;
    border-radius: 8px;
    background: rgb(241,241,241);
    margin: 0.5rem auto 0;
  }
  .q4{
    color: rgb(51,51,51);
    font-size: 0.7rem;
    margin-left: 0.5rem;
    line-height: 1.8rem;
  }
  .q6{
    margin: 0.5rem auto 1rem;
    width: 15.75rem;
    height: 1.8rem;
    line-height: 1.8rem;
    border-radius: 0.4rem;
    background-color: rgba(196, 77, 65, 1);
    text-align: center;
    color: #fff;
    font-size: 0.7rem;
    display: block;
    border: none;
    outline:none;
  }
  .q6.active{
    color: #999;
    background-color: #d8d8d8;
  }
</style>



// WEBPACK FOOTER //
// src/view/register.vue